import React from "react";
import { confirmAlert } from "react-confirm-alert";
import { api, constants } from "../utils";

function setLoadedToRTO(contractId, onSuccess, onError) {
  api.post("contract/SetFollowupStatus", {
    id: contractId,
    followUpType: constants.FOLLOW_UP.RTO,
    complete: true,
  }).then((r) => {
    if (r.data.success) {
      onSuccess && onSuccess();
    } else {
      onError && onError(r.data.message);
    }
  }).catch((e) => console.error(e));
}

function checkRTOProExportReadinessThenReview(contractId, onReadyToReview, onError) {
  api.fetch(`contract/CheckRTOProExportReadiness/${contractId}`).then((r) => {
    if (!r.data.success) {
      onError && onError(r.data.message);
      return;
    }
    const readiness = r.data.message;
    if (readiness.blocked) {
      onError && onError(readiness.blockedReason);
      return;
    }
    if (readiness.warnings && readiness.warnings.length > 0) {
      confirmAlert({
        title: "RTOPro Export Warnings",
        message: (
          <div>
            <p>Continue anyway, or cancel and fill in first:</p>
            <ul>
              {readiness.warnings.map((w, i) => <li key={i}>{w}</li>)}
            </ul>
          </div>
        ),
        buttons: [
          { label: "Continue", onClick: () => onReadyToReview(contractId) },
          { label: "Cancel" },
        ],
      });
    } else {
      onReadyToReview(contractId);
    }
  }).catch((e) => console.error(e));
}

export default {
  // Call when the RTO follow-up icon/button is toggled on. Asks the user whether to
  // also generate the RTOPro XML/PDF export, or just mark the contract loaded to RTO
  confirmSetLoadedToRTO(contractId, onReadyToReview, onSuccess, onError) {
    confirmAlert({
      title: "Export to RTOPro?",
      message:
        "Do you want to export this contract to RTOPro?",
      buttons: [
        { label: "Yes", onClick: () => checkRTOProExportReadinessThenReview(contractId, onReadyToReview, onError) },
        { label: "No, it's already loaded", onClick: () => setLoadedToRTO(contractId, onSuccess, onError) },
        { label: "Cancel" },
      ],
    });
  },
};
